<template>
<transition name="payScheme">
    <div class="pay_scheme_body" v-if="payScheme&&index>=0" :data-index="index" :data-limit="isLimit?'Y':'N'" :data-year="isYear?'Y':'N'" :data-vip="isVIP?'Y':'N'" :data-index-max="indexMax" :data-language="$i18n.locale">
      <div class="pay_scheme_cuppon" v-if="(payScheme.arguments&&payScheme.arguments['cuppon'])">
        <div class="cuppon_num">{{"-"+payScheme.arguments['cuppon']}}<span>%</span></div>
      </div>
      <div class="pay_scheme_type">{{$t('language.paySystem.arguments.title.'+payScheme.arguments['title'])}}</div>
      <div class="pay_scheme_price" v-if="payScheme.payMony" :style="getPriceSize()">
        {{payScheme.payMony[lang]}}
        <span class="pay_scheme_oldPrice" v-if="payScheme.oldPayMony&&index>=0" :style="getOldPriceSize()">{{payScheme.oldPayMony[lang]}}</span>
      </div>
      <div class="pay_scheme_cycle">
        <div v-if="payScheme.attrib==3||payScheme.type=='Lifetime'">{{$t('language.paySystem.Onetime')}}</div>
        <div v-if="payScheme.type=='Monthly'">{{$t('language.paySystem.tabPayScheme.perMonth')}}</div>
        <div v-if="payScheme.type=='Yearly'&&(payScheme.attrib==1||($parent.nowScheme&&isActiveLoginType($parent.nowScheme.cartId)))">{{$t('language.paySystem.tabPayScheme.perYear')}}</div>
        <div v-if="payScheme.type=='Yearly'&&payScheme.isDifferencePrice==1" v-html="$t('language.paySystem.tabPayScheme.perNextYear',{'price':payScheme.payMony['basic'][lang]})"></div>
      </div>
      <div class="pay_scheme_btn scheme_btn" @click="upgradePlan()">
        {{$t('language.paySystem.buyNow')}}
      </div>
      <div class="pay_scheme_tips" v-if="payScheme.parameters">
        <div v-if="payScheme.level==2||payScheme.level==3" class="pay_scheme_tip">
          {{$t('language.paySystem.limitTips')}}
          <span>
            <div class="ask">
              <div class="plan-questionTxt">{{$t('language.paySystem.arguments.tips.'+payScheme.arguments['title'])}}</div>
            </div>
          </span>
        </div>
        <div v-else class="pay_scheme_tip">
          {{$t('language.paySystem.unlimitTips')}}
        </div>
      </div>
      <div class="by_traffic_space" v-if="isTraffic"></div>
      <div class="support_items" v-if="isVIP&&!isTraffic">
        <div class="support_group">
          <div class="support_item">{{$t('language.paySystem.supportItem.unlimitedDataTraffic')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.unlimitedInsProfile')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.unlimitedAllFeatures')}}</div>
        </div>
      </div>
      <div class="support_items" v-if="!isVIP">
        <div class="support_group">
          <div class="support_item" v-if="isLimit&&!isYear&&index==0">{{$t('language.paySystem.supportItem.gb100')}}</div>
          <div class="support_item" v-if="isLimit&&!isYear&&index==0">{{$t('language.paySystem.supportItem.ins10')}}</div>
          <div class="support_item" v-if="isLimit&&!isYear&&index==1">{{$t('language.paySystem.supportItem.gb200')}}</div>
          <div class="support_item" v-if="isLimit&&!isYear&&index==1">{{$t('language.paySystem.supportItem.ins20')}}</div>
          <div class="support_item" v-if="isLimit&&isYear&&index==0">{{$t('language.paySystem.supportItem.gb1200')}}</div>
          <div class="support_item" v-if="isLimit&&isYear&&index==0">{{$t('language.paySystem.supportItem.ins120')}}</div>
          <div class="support_item" v-if="isLimit&&isYear&&index==1">{{$t('language.paySystem.supportItem.gb2400')}}</div>
          <div class="support_item" v-if="isLimit&&isYear&&index==1">{{$t('language.paySystem.supportItem.ins240')}}</div>
          <div class="support_item" v-if="!isLimit&&index==0">{{$t('language.paySystem.supportItem.gbUnlimitedYear')}}</div>
          <div class="support_item" v-if="!isLimit&&index==0">{{$t('language.paySystem.supportItem.unlimitedInsProfile')}}</div>
          <div class="support_item" v-if="!isLimit&&index==1">{{$t('language.paySystem.supportItem.gbUnlimitedLifetime')}}</div>
          <div class="support_item" v-if="!isLimit&&index==1">{{$t('language.paySystem.supportItem.unlimitedInsProfile')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.pdfUnlimited')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.threads10')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.scheduled')}}</div>
        </div>
        <div class="support_group">
          <div class="support_item">{{$t('language.paySystem.supportItem.acrossClouds')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.offline')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.subAccounts1000')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.highSpeed')}}</div>
        </div>
        <div class="support_group">
          <div class="support_item">{{$t('language.paySystem.supportItem.syncMode10')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.realSync')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.passwordProtected')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.subAccounts')}}</div>
        </div>
        <div class="support_group">
          <div class="support_item">{{$t('language.paySystem.supportItem.cloud30')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.unlimitedCloud')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.singleLog')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.support365')}}</div>
        </div>
      </div>
    </div>
    <!-- vip用户当前套餐展示用组件页面 -->
    <div class="pay_scheme_body cur_scheme_body" v-if="payScheme&&index<0" :data-cur-year-unlimited="curPlanIsYearUnlimited?'Y':'N'">
      <div class="pay_scheme_type">{{payScheme.name}}</div>
      <div class="pay_scheme_price" v-if="payScheme.payMony">
        {{payScheme.payMony}}
      </div>
      <div class="pay_scheme_cycle">
        <div v-if="payScheme.type=='Lifetime'">{{$t('language.paySystem.Onetime')}}</div>
        <div v-if="payScheme.type=='Monthly'">{{$t('language.paySystem.tabPayScheme.perMonth')}}</div>
        <div v-if="payScheme.type=='Yearly'">{{$t('language.paySystem.tabPayScheme.perYear')}}</div>
      </div>
      <div class="now_scheme_btn scheme_btn" @click="showNowPayScheme()">
        {{$t('language.popup.upgradeAccountPopup.currentPlan')}}
      </div>
      <div class="support_items">
        <div class="support_group">
          <div class="support_item">{{ curPlanGBText }}</div>
          <div class="support_item">{{ curPlanInsCountText }}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.unlimitedAllFeatures')}}</div>
        </div>
      </div>
    </div>
    <!-- 非vip用户介绍付费功能用组件页面 -->
    <div class="pay_scheme_body no_scheme_body" v-if="!payScheme">
      <div class="pay_scheme_type">{{$t('language.paySystem.freePlanPopup.itemValue_free')}}</div>
      <div class="pay_scheme_price">$0</div>
      <div class="pay_scheme_cycle"></div>
      <div class="cur_plan_btn">
        <img src="../../../../assets/images/paySystem/curPlan.svg">
        <span>{{ $t('language.paySystem.supportItem.yourCurPlan') }}</span>
      </div>
      <div class="support_items">
        <div class="support_group">
          <div class="support_item">{{$t('language.paySystem.supportItem.gb5')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.ins1')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.pdf50')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.threads2')}}</div>
          <div class="support_item support_no">{{$t('language.paySystem.supportItem.scheduled')}}</div>
        </div>
        <div class="support_group">
          <div class="support_item">{{$t('language.paySystem.supportItem.acrossClouds')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.offline')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.subAccounts3')}}</div>
          <div class="support_item support_no">{{$t('language.paySystem.supportItem.highSpeed')}}</div>
        </div>
        <div class="support_group">
          <div class="support_item">{{$t('language.paySystem.supportItem.syncMode4')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.realSync')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.passwordProtected')}}</div>
          <div class="support_item support_no">{{$t('language.paySystem.supportItem.subAccounts')}}</div>
        </div>
        <div class="support_group">
          <div class="support_item">{{$t('language.paySystem.supportItem.cloud30')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.unlimitedCloud')}}</div>
          <div class="support_item">{{$t('language.paySystem.supportItem.singleLog')}}</div>
          <div class="support_item support_no">{{$t('language.paySystem.supportItem.support365')}}</div>
        </div>
      </div>
      <!-- 
      <div class="no_scheme_title">
        <img src="../../../../assets/images/paySystem/icon_stars.png">
        {{$t('language.paySystem.tabPayScheme.advanced')}}
      </div>
      <div class="no_scheme_msg" v-if="$parent.clickIndex==0">
        {{$t('language.paySystem.tabPayScheme.payPremium')}}
      </div>
      <div class="no_scheme_msg" v-else>
        {{$t('language.paySystem.tabPayScheme.payUnlimited')}}
      </div>
      <div class="no_scheme_tips" :class="getTipTopHight()">
        <div class="no_scheme_tip" v-if="$parent.clickIndex==0">
          {{$t('language.paySystem.tabPayScheme.freeTip1')}}
        </div>
        <div class="no_scheme_tip" v-else>
          {{$t('language.paySystem.tabPayScheme.freeTip2')}}
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip11')}}
          <span>
            <div class="ask">
              <div class="plan-questionTxt">{{$t('language.paySystem.tabPayScheme.freeTipTitle6')}}</div>
            </div>
          </span>
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip3')}}
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip4')}}
          <span>
            <div class="ask">
              <div class="plan-questionTxt">{{$t('language.paySystem.tabPayScheme.freeTipTitle1')}}</div>
            </div>
          </span>
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip10')}}
          <span>
            <div class="ask">
              <div class="plan-questionTxt">{{$t('language.paySystem.tabPayScheme.freeTipTitle5')}}</div>
            </div>
          </span>
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip5')}}
          <span>
            <div class="ask">
              <div class="plan-questionTxt">{{$t('language.paySystem.tabPayScheme.freeTipTitle2')}}</div>
            </div>
          </span>
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip6')}}
          <span>
            <div class="ask">
              <div class="plan-questionTxt">{{$t('language.paySystem.tabPayScheme.freeTipTitle3')}}</div>
            </div>
          </span>
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip7')}}
          <span>
            <div class="ask">
              <div class="plan-questionTxt">{{$t('language.paySystem.tabPayScheme.freeTipTitle4')}}</div>
            </div>
          </span>
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip8')}}
        </div>
        <div class="no_scheme_tip">
          {{$t('language.paySystem.tabPayScheme.freeTip9')}}
        </div>
      </div>
      -->
    </div>
</transition>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import constant from '../../../../js/constant';
export default {
  props: ['payScheme', 'index', 'user', 'isLimit', 'isYear', 'isVIP', 'isTraffic', 'indexMax'],
  mounted() {
  },
  data: function () {
    return {
      lang: commonUtils.getPriceForLange(localStorage.getItem("locale")),
    }
  },
  computed: {
    // 当前套餐是否是年无限
    curPlanIsYearUnlimited() {
      var title = this.payScheme.arguments.title;
      return title == 'yearlyUnlimit';
    },
    // 当前套餐流量
    curPlanGBText() {
      var title = this.payScheme.arguments.title;
      if (title == 'monthly100GB') {
        return this.$t('language.paySystem.supportItem.gb100');
      } else if (title == 'monthly200GB') {
        return this.$t('language.paySystem.supportItem.gb200');
      } else if (title == 'monthlyUnlimit') {
        return this.$t('language.paySystem.supportItem.unlimitedDataTraffic');
      } else if (title == 'yearly1200GB') {
        return this.$t('language.paySystem.supportItem.gb1200');
      } else if (title == 'yearly2400GB') {
        return this.$t('language.paySystem.supportItem.gb2400');
      } else if (title == 'yearlyUnlimit') {
        return this.$t('language.paySystem.supportItem.gbUnlimitedYear');
      } else if (title == 'lifetimeUnlimit') {
        return this.$t('language.paySystem.supportItem.gbUnlimitedLifetime');
      } else if (title == 'package50GB') {
        return this.$t('language.paySystem.supportItem.gbPackage50');
      } else if (title == 'package100GB') {
        return this.$t('language.paySystem.supportItem.gbPackage100');
      } else if (title == 'giveAway500GB') {
        return this.$t('language.paySystem.supportItem.gbGiveAway500');
      } else if (title == 'giveAway200GB') {
        return this.$t('language.paySystem.supportItem.gbGiveAway200');
      } else {
        return '';
      }
    },
    // 当前套餐Ins个数
    curPlanInsCountText() {
      var title = this.payScheme.arguments.title;
      if (title == 'monthly100GB') {
        return this.$t('language.paySystem.supportItem.ins10');
      } else if (title == 'monthly200GB') {
        return this.$t('language.paySystem.supportItem.ins20');
      } else if (title == 'monthlyUnlimit') {
        return this.$t('language.paySystem.supportItem.unlimitedInsProfile');
      } else if (title == 'yearly1200GB') {
        return this.$t('language.paySystem.supportItem.ins120');
      } else if (title == 'yearly2400GB') {
        return this.$t('language.paySystem.supportItem.ins240');
      } else if (title == 'yearlyUnlimit') {
        return this.$t('language.paySystem.supportItem.unlimitedInsProfile');
      } else if (title == 'lifetimeUnlimit') {
        return this.$t('language.paySystem.supportItem.unlimitedInsProfile');
      } else if (title == 'package50GB') {
        return this.$t('language.paySystem.supportItem.insPackage50');
      } else if (title == 'package100GB') {
        return this.$t('language.paySystem.supportItem.insPackage100');
      } else if (title == 'giveAway500GB') {
        return this.$t('language.paySystem.supportItem.insGiveAway500');
      } else if (title == 'giveAway200GB') {
        return this.$t('language.paySystem.supportItem.insGiveAway200');
      } else {
        return '';
      }
    },
  },
  methods: {
    isActiveLoginType(type){
        return constant.activeCartIdList.includes(type);
    },
    showNowPayScheme(){
      var nowPayScheme = this.$parent.nowScheme;
      if(nowPayScheme&&this.isActiveLoginType(nowPayScheme.cartId)){
        return;
      }
      var user = commonUtils.getUser();
      if(user.vip&&user.subscrId.slice(0, 2) === "LS") {
        //兑换码套餐
        this.$parent.$refs.licenseShowDialog.isShow = true;
      }else if(user.vip&&nowPayScheme&&nowPayScheme.attrib>10&&nowPayScheme.attrib<13){
        //ios或者google套餐
        this.$parent.$refs.appNowPaySchemeDialog.payInfo = {
          name:nowPayScheme.name,
          transactionId:user.subscrId,
          type:nowPayScheme.attrib==11?"ios":"google",
          isSubscribe:user.payStatus=="Completed",
          nextTime: this.getNextTime(user.payTime,user.payType),
        }
        this.$parent.$refs.appNowPaySchemeDialog.appNowPaySchemeShow = true;
      }else{
        this.$parent.getItemSubScrition();
        this.$parent.$refs.nowPaySchemeDialog.nowPaySchemeShow = true;
      }
    },
    //通过支付时间和状态获取下一次支付时间
    getNextTime(payTime,type){
      // 获取支付时间
      var date = new Date(payTime);
      if(type == "Yearly"){
        //延后一年
        date.setFullYear(date.getFullYear() + 1);
      }
      if(type == "Monthly"){
        //延后一月
        date.setMonth(date.getMonth() + 1);
      }
      if(type == "Lifetime"){
        return "";
      }
      let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
      let time = lang=='en'?commonUtils.transferTime(date.getTime()):commonUtils.transferForMatTime(date.getTime());
      return time;
    },
    upgradePlan () {
      let parameters = this.payScheme.parameters;
      parameters.productId = this.payScheme.cartId;
      parameters.coupon = this.payScheme.coupon;
      if(this.$parent.nowScheme&&this.isActiveLoginType(this.$parent.nowScheme.cartId)){
        // let cartId = this.$parent.nowScheme.cartId;
        var user = commonUtils.getUser();
        var userType = user.loginType;
        if(userType=='a202302'){
          parameters.xPage = '2023-CB';
        }else if((user.userExpandList&&"auth1"==user.userExpandList[0].value)){
            parameters.xPage = 'auth1';
        }else if(constant.active500GBList.includes(userType)||constant.active200GBList.includes(userType)){
          parameters.xPage = '2024-'+userType;
        }
      }
      this.$parent.upgradePlan(parameters);
    },
    getPriceSize () {
      let result;
      let lang = this.$i18n.locale;
      if(lang == 'france' || lang == 'spanish' || lang == 'deutsch' || lang == 'italian' || lang == 'nederlands'){
        result = 'font-size:43px;'
      }
      if(lang == 'japanese' || lang == 'portuguese'){
        result = 'font-size:40px;'
      }
      if(lang == 'traditionalChinese'){
        result = 'font-size:35px;'
      }
      return result;
    },
    getOldPriceSize () {
      let result;
      let lang = this.$i18n.locale;
      if(lang == 'traditionalChinese' || lang == 'portuguese'){
        result = 'font-size:25px;'
      }
      return result;
    },
    getTipTopHight () {
      let result;
      let lang = this.$i18n.locale;
      if(lang == 'japanese' || lang == 'france' || lang == 'deutsch' || lang == 'nederlands'){
        result = 'tip_top10';
      }
      if(lang == 'portuguese'){
        result = 'tip_top15';
      }
      if(lang == 'italian' || lang == 'spanish'){
        result = 'tip_top20';
      }
      return result;
    },
  },
}
</script>

<style>
.pay_scheme_body {
  width: 400px;
  border-radius: 16px;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
  border: 3px solid #FF7516;
  background: #FFFFFF;
  /*no*/
  box-sizing: border-box;
  text-align: center;
  float: left;
  position: relative;
}

.pay_scheme_type{
  margin-top: 60px;
  margin-bottom: 40px;
  height: 36px;
  line-height: 36px;
  font-size: 32px;
  font-weight: bold;
  color: #FF7516;
}

.pay_scheme_price{
  color: #000000;
  font-size: 40px;
  line-height: 48px;
  height: 48px;
}

.pay_scheme_oldPrice{
  font-size: 16px;
  font-weight: bold;
  color: #999999;
  text-decoration: line-through;
}

.pay_scheme_cycle{
  color: #000000;
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  margin-top: 8px;
}

.pay_scheme_cycle>div {
  display: inline-block;
  margin: 0 5px;
}

.scheme_btn{
  height: 60px;
  line-height: 60px;
  width: 306px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bold;
  color: #FFFFFF;
  margin: 40px auto 24px auto;
  user-select: none;
  cursor: pointer;
  background: #FF7516;
}

.now_scheme_btn{
  border: 1Px solid #ff9330;
  border-radius: 10Px;
  color: #ff9330;
}

.pay_scheme_tips{
  display: none;
  color: #a3adbd;
  font-size: 14Px;
  position: absolute;
  width: 100%;
  bottom: 20Px;
}

.pay_scheme_tips .pay_scheme_tip{
  margin: auto;
  width: 72%;
}
/** 以下为提示用页面的css **/
.no_scheme_body {
  border: 1px solid #E6E8E9;
}

.no_scheme_body>.pay_scheme_type {
  color: #4EC46A;
}

.no_scheme_title{
  margin: 30Px 0 6Px;
  padding-top: 10Px;
  font-size: 24Px;
  height: 32Px;
  color: #1a1a1a;
  line-height: 22Px;
  white-space: nowrap;
}

.no_scheme_title img{
  vertical-align: bottom;
  margin-right: 10Px;
}

.no_scheme_msg{
  font-size: 14Px;
  color: #6f7886;
  text-align: left;
}

.no_scheme_tips{
  margin-top: 40Px;
  font-size: 14Px;
  line-height: 14Px;
  color: #333333;
  text-align: left;
}

.no_scheme_tips .no_scheme_tip{
  padding-left: 26Px;
  margin-bottom: 12Px;
  background: url("../../../../assets/images/paySystem/icon_tick.png") no-repeat;
}

.no_scheme_tips .no_scheme_tip img{
  margin-left: 8Px;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
}

.pay_scheme_cuppon{
  width: 80px;
  height: 80px;
  background: url("../../../../assets/images/paySystem/bg_discount.svg") no-repeat;
  position: absolute;
  right: -1px;
  top: -1px;
  user-select: none;
}

.pay_scheme_cuppon .cuppon_num{
  font-family: Source Han Sans CN;
  transform: rotate(45deg);
  position: absolute;
  font-size: 24px;
  font-weight: bold;
  right: 0px;
  top: 10px;
  color: #ffffff;
}

.pay_scheme_cuppon .cuppon_num span{
  font-size: 24px;
  font-weight: bold;
}

.tip_top10 {
  margin-top: 10Px;
}

.tip_top15 {
  margin-top: 15Px;
}

.tip_top20 {
  margin-top: 20Px;
}

.pay_scheme_tips span,
.no_scheme_tip span{
  position: relative;
}


.pay_scheme_body .ask{
  width: 15Px;
  height: 15Px;
  display: inline-block;
  position: absolute;
  top: 1Px;
  left: 5Px;
  background: url("../../../../assets/images/paySystem/icon_problem.png") no-repeat;
  cursor: pointer;
}

.pay_scheme_body .ask:hover .plan-questionTxt {
  display: block;
}

.plan-questionTxt {
  text-align: left;
  display: none;
  position: absolute;
  width: 250Px;
  border: 1Px solid #5562b4;
  border-radius: 3Px;
  left: 0 !important;
  top: 25Px !important;
  background: #fff;
  z-index: 3;
  font-size: 12Px;
  box-sizing: border-box;
  padding: 5Px;
  line-height: 20Px;
  color: #333333;
}

/* 套餐外框间距 */
.pay_scheme_body[data-vip] {
  margin-left: 24px;
}

/* 100GB月，1200GB年，年无限，特殊处理 */
.pay_scheme_body[data-vip=N][data-limit=N][data-index='0']>.pay_scheme_type,
.pay_scheme_body[data-vip=N][data-limit=Y][data-year=Y][data-index='0']>.pay_scheme_type,
.pay_scheme_body[data-vip=N][data-limit=Y][data-year=N][data-index='0']>.pay_scheme_type {
  color: #3092ED;
}
.pay_scheme_body[data-vip=N][data-limit=N][data-index='0']>.pay_scheme_cuppon,
.pay_scheme_body[data-vip=N][data-limit=Y][data-year=Y][data-index='0']>.pay_scheme_cuppon {
  background: url("../../../../assets/images/paySystem/bg_discount_blue.svg") no-repeat;
}
.pay_scheme_body[data-vip=N][data-limit=Y][data-year=N][data-index='0']>.scheme_btn {
  background: #3092ED;
}

/* 第一个套餐边框特殊处理 */
.pay_scheme_body[data-vip][data-index='0'] {
  border: 1px solid #E6E8E9;
}

/* 最后个套餐边框特殊处理 */
.pay_scheme_body[data-vip=Y][data-year=Y]:last-child {
  border: 3px solid #FF7516;
}

/* 免费按钮 */
.cur_plan_btn {
  height: 60px;
  line-height: 60px;
  width: 306px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #333333;
  margin: 40px auto 24px auto;
  cursor: default;
}
.cur_plan_btn>* {
  vertical-align: middle;
}
.cur_plan_btn>img {
  margin-right: 5px;
}

/* 支持的功能，外框 */
.support_items {
  margin-bottom: 32px;
}
/* 支持的功能，组 */
.support_group {
  margin-bottom: 8px;
}
/* 支持的功能，项 */
.support_item {
  font-family: Source Han Sans CN;
  font-size: 14px;
  min-height: 32px;
  line-height: 32px;
  text-align: left;
  color: #000000;
  padding-left: 68px;
  padding-right: 40px;
  background-image: url("../../../../assets/images/paySystem/itemYes.svg");
  background-repeat: no-repeat;
  background-position: 44px 8px;
}
/* 不支持的 */
.support_no {
  color: #999999;
  background-image: url("../../../../assets/images/paySystem/itemNo.svg");
}

/* 当前付费套餐 */
.cur_scheme_body {
  border: 1px solid #E6E8E9;
}
.cur_scheme_body>.scheme_btn {
  background: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  border: 1px solid #333333;
}

/* 付费状态下标题文字变小 */
.cur_scheme_body>.pay_scheme_type,
.pay_scheme_body[data-vip=Y]>.pay_scheme_type {
  font-size: 28px;
}

/* 弹窗里面的付费套餐，-----------------------------------------特殊处理 */
/* 优惠背景 */
.pay_scheme_body[data-popup]>.pay_scheme_cuppon {
  width: 85px;
  height: 26px;
  line-height: 26px;
  border-radius: 2px 12px 2px 12px;
  background: linear-gradient(90deg, #FF5B24 0%, #FF8E47 100%);
}
/* 优惠文字 */
.pay_scheme_body[data-popup]>.pay_scheme_cuppon>.cuppon_num>span,
.pay_scheme_body[data-popup]>.pay_scheme_cuppon>.cuppon_num {
  position: relative;
  transform: none;
  font-size: 18px;
  top: 0;
}
/* 套餐标题 */
.pay_scheme_body[data-popup]>.pay_scheme_type {
  color: #333333;
  font-size: 24px;
  height: 60px;
  line-height: 60px;
  margin-top: 30px;
  margin-bottom: 110px;
}
/* 套餐价格 */
.pay_scheme_body[data-popup]>.pay_scheme_price {
  font-size: 40px;
  font-weight: bold;
  color: #FF6C19;
}
/* 套餐价格，老价格 */
.pay_scheme_body[data-popup]>.pay_scheme_price>.pay_scheme_oldPrice {
  font-size: 16px;
    font-weight: bold;
    color: #BDBDBD;
}
/* 描述文字 */
.pay_scheme_body[data-popup]>.pay_scheme_cycle {
  font-size: 12px;
  color: #BDBDBD;
  margin-top: 8px;
}
/* 按钮 */
.pay_scheme_body[data-popup]>.scheme_btn {
  height: 40px;
    width: 240px;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    border-radius: 8px;
    background: linear-gradient(176deg, #FFA133 5%, #F58427 81%);
    user-select: none;
    margin: 15px auto 30px auto;
}
/* 支持项外框 */
.pay_scheme_body[data-popup]>.support_items {
  position: absolute;
  top: 110px;
}
/* 支持项 */
.pay_scheme_body[data-popup] .support_item {
  font-size: 14px;
  color: #333333;
  height: 16px;
  line-height: 16px;
  min-height: 16px;
  margin-bottom: 12px;
  margin-left: 98px;
  padding-left: 0px;
  text-indent: 24px;
  background-image: url("../../../../assets/images/imageSaver/upgradeItem.svg");
  background-position: 0px center;
}

/* 德语特殊处理 */
.pay_scheme_body[data-popup][data-language=deutsch] .support_item {
  margin-left: 58px;
}

/* 当前套餐是年无限时--------------------------------------------- */
.cur_scheme_body[data-cur-year-unlimited=Y] {
  width: 612px;
}
.cur_scheme_body[data-cur-year-unlimited=Y]>.support_items {
  margin-left: 105px;
}

/* 只能升级终身无限时 */
.pay_scheme_body[data-index-max='1'] {
  width: 612px;
}
.pay_scheme_body[data-index-max='1']>.support_items {
  margin-left: 105px;
}

/* 购买流量按钮下间距 */
.by_traffic_space {
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_pay_system/tab_pay_scheme.vue